/**
 * Present a blobURL as a downloadable file to the browser. Use this instead of
 * pointing the user at a link, since those requests can miss the auth headers.
 * Inspired by https://github.com/kennethjiang/js-file-download/.
 *
 * Its own light module (no `@/utils`, which pulls in `@/main` and the whole app
 * graph) so stores and components can reuse it without dragging that in.
 *
 * @param filename the name the file is saved as
 */
export function downloadBlob(blobURL: string, filename: string) {
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", filename);
    document.body.appendChild(tempLink);
    tempLink.click();

    // Resolves "webkit blob resource error 1"
    setTimeout(() => {
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }, 200);
}
